var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"chart"}),(_vm.loading)?_c('p',{staticClass:"p-4"},[_c('b-skeleton',{attrs:{"active":""}}),_c('b-skeleton',{attrs:{"height":"120px"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }